import { hexToRgb } from './hexToRgb';

// color contrast - https://www.w3.org/WAI/WCAG21/Techniques/general/G145#procedure
// ideally we would check against 4.5 instead of 3 but partners don't like that
export function checkContrastAgainstWhite(color: string) {
  const [r, g, b] = hexToRgb(color, [255, 255, 255]).map((n) => {
    const normalizedN = n / 255;
    return normalizedN > 0.03928
      ? Math.pow((normalizedN + 0.055) / 1.055, 2.4)
      : normalizedN / 12.92;
  });
  return 1.05 / (r * 0.2126 + g * 0.7152 + b * 0.0722 + 0.05) >= 3;
}
